<template>
    <div>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">农行交易明细</span>
                        <span style="margin-left:20px;">统计时间:</span>
                        <DatePicker type="daterange"
                            v-model="selectDates"
                            size="small"
                            transfer
                            placement="bottom-end"
                            placeholder="选择期初和期末时间"
                            style=" margin-left:4px;width: 200px"
                            @on-change="onDateChange"></DatePicker>
                        <span style="margin-left:20px;">交易状态:</span>
                        <Select v-model="searchCondition.status"
                            size="small"
                            clearable
                            style="width:120px;">
                            <Option value=" ">全部</Option>
                            <Option value="08">已支付</Option>
                            <Option value="ZY">未支付</Option>
                        </Select>
                        <span style="margin-left:20px;">支付方式:</span>
                        <Select v-model="searchCondition.payType"
                            size="small"
                            clearable
                            style="width:120px;">
                            <Option value=" ">全部</Option>
                            <Option value="weixinpay">微信</Option>
                            <Option value="ALI_PRECREATE">支付宝</Option>
                            <Option value="ImmediatePay">农行</Option>
                        </Select>
                        <span style="margin-left:20px;">会员账号:</span>
                        <Input v-model="searchCondition.memberName"
                            size="small"
                            clearable
                            placeholder="输入会员账号"
                            style="width: 100px" />
                        <Button type="primary"
                            size='small'
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="getAbcTransactionList()">查询</Button>
                    </div>
                    <div class="right-bar">

                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.statColumns"
                    :data="mainTable.data"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getAbcTransactionList"
                    :showPage="false" />
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="12">
                <Page style="margin-top:10px;"
                    :total="pageInfo.total"
                    :page-size="pageInfo.pageLength"
                    :current="pageInfo.pageStart"
                    :page-size-opts="pageInfo.pageType"
                    show-elevator
                    show-sizer
                    placement="top"
                    @on-change="tablePageOnChange"
                    @on-page-size-change="tablePageOnSizeChange" />
                </Col>
                <Col span="12"
                    style="padding-top:10px;font-size:18px;">
                <span>合计:{{totalValue}}元</span>
                <span v-for="(item, index) in totalSubValue"
                    :key="index"
                    style="margin-left:20px; ">{{payTypeText[item.payType] + ':' + item.value + '元'}}</span>
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import { numberToFixed, number2ThousandsFormat } from '@/components/number-input/display-format';
import { getThisMonthStart, getTodayDateString } from '@/libs/logic';
import { QueryABCTransaction, notifyABCPay } from '@/api/modules/finance-management/member-transaction';
import { FILE_SERVER } from '@/api/modules/files';

export default {
    name: 'sale-stat-list',
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            selectDates: [],
            searchCondition: {
                beginDate: '',
                endDate: '',
                beginHour: 0,
                endHour: 23,
                status: '08',
                payType: '',
                memberName: '',
                pageSize: 10,
                pageIndex: 1
            },
            pageInfo: {
                total: 0,
                pageLength: 10,
                pageStart: 1,
                pageType: [10, 20, 30]
            },
            mainTable: {
                statColumns: [
                    { title: '#', key: 'index', width: 60, align: 'center' },
                    { title: '金额', key: 'value', align: 'center' },
                    { title: '交易类型', key: 'type', align: 'center' },
                    { title: '单号', key: 'code', width: 190, align: 'center' },
                    { title: '交易时间', key: 'date', width: 170, align: 'center' },
                    {
                        title: '状态', key: 'status', align: 'center',
                        render: (h, params) => {
                            return h('span', {}, this.payStatusText[params.row.status]);
                        }
                    },
                    { title: '客户', key: 'customer', align: 'center' },
                    { title: '商家', key: 'shop', width: 120, align: 'center' },
                    { title: '会员账号', key: 'memberName', align: 'center' },
                    {
                        title: '支付方式', key: 'payType', align: 'center',
                        render: (h, params) => {
                            return h('span', {}, this.payTypeText[params.row.payType]);
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small'
                                },
                                style: {
                                    visibility: params.row.status === '08' ? 'visible' : 'hidden'
                                },
                                on: {
                                    click: () => {
                                        this.SendBackPayStatus(params.row);
                                    }
                                }
                            }, '同步数据');
                        }
                    }
                ],
                data: [],
                tableSearch: search.getSearchParams(),
                loading: false
            },
            totalSubValue: [],
            totalValue: 0,
            payTypeText: { 'weixinpay': '微信', 'ALI_PRECREATE': '支付宝', 'ImmediatePay': '农行' },
            payStatusText: { '08': '已支付', 'ZY': '未支付' }
        };
    },
    mounted() {
        let beginDate = this.getTodayDateString();
        let endDate = this.getTodayDateString();
        this.selectDates = [beginDate, endDate];
        this.searchCondition.beginDate = this.selectDates[0];
        this.searchCondition.endDate = this.selectDates[1];
        this.init();
    },
    methods: {
        getTodayDateString,
        getThisMonthStart,
        SendBackPayStatus(row) {
            if (row.status != '08') {
                this.$Modal.error({
                    title: '错误',
                    content: '未支付数据，无法同步.'
                });
                return;
            }

            this.$Modal.confirm({
                title: '确认同步支付状态？',
                onOk: () => {
                    this.mainTable.loading = true;
                    notifyABCPay({ orderNo: row.code, orderAmount: row.value }).then(res => {
                        if (res.code === 0) {
                            this.$Message.success('同步成功');
                        }
                        this.mainTable.loading = false;
                    });
                }
            });
        },
        init() {
            this.getAbcTransactionList();
        },
        onDateChange() {
            this.searchCondition.beginDate = this.selectDates[0];
            this.searchCondition.endDate = this.selectDates[1];
        },
        tablePageOnChange(e) {
            this.searchCondition.pageIndex = e;
            this.getAbcTransactionList();
        },
        tablePageOnSizeChange(e) {
            this.searchCondition.pageSize = e;
            this.getAbcTransactionList();

        },
        getAbcTransactionList() {
            this.mainTable.loading = true;
            QueryABCTransaction(this.searchCondition).then(res => {
                this.mainTable.loading = false;
                if (res.code === 0) {
                    this.mainTable.data = res.data.transactionList;
                    let tt = 0;
                    let index = 1;
                    this.mainTable.data.forEach(e => {
                        tt += e.value;
                        e.index = index++;
                    });
                    this.mainTable.data.push({
                        value: numberToFixed(tt, 2),
                        index: '小计'
                    });
                    this.pageInfo.total = res.data.totalCount;
                    this.totalValue = res.data.totalValue;
                    this.totalSubValue = res.data.totalSubValue;
                }
            }).catch(() => {
                this.mainTable.loading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
